<template>
  <div class="introduction-content2">
    <div class="title-container">
      <div class="title-text">团队管理</div>
      <div class="title-text-en">Team Management</div>
    </div>
    
    <div class="carousel-wrapper">
      <div class="carousel-container">
        <div 
          class="carousel-track"
          :class="[`active-index-${activeIndex}`, { dragging: isDragging }]"
          :style="dragStyle"
          @mousedown="handleMouseDown"
          @mousemove="handleMouseMove"
          @mouseup="handleMouseUp"
          @mouseleave="handleMouseUp"
          @touchstart="handleTouchStart"
          @touchmove="handleTouchMove"
          @touchend="handleTouchEnd"
        >
          <div 
            v-for="(card, index) in cards" 
            :key="index"
            class="carousel-card"
            :class="{ active: index === activeIndex }"
          >
            <div class="card-content">
              <div class="avatar-container">
                <img :src="card['avatar-img']" alt="avatar" class="avatar-img" draggable="false" />
              </div>
              <div class="intro-container">
                <div class="intro-text">{{ card.introduction }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="carousel-dots">
        <span 
          v-for="(card, index) in cards" 
          :key="index"
          class="dot"
          :class="{ active: index === activeIndex }"
          @click="goToSlide(index)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroductionContent2',
  data() {
    return {
      activeIndex: 2,
      cards: [
        { 
          'avatar-img': 'https://ustatic.hudongmiao.com/miao/common/Tiger_1768211443948433c6e.webp', 
          introduction: 'Tiger，上海嗨喵网络科技有限公司CTO，曾任职腾讯高级开发工程师、火影忍者页游产品经理，连续创业者，拥有超过15年的软件开发经验和11年的软件开发管理经验，曾亲自负责和指导过多个大项目的研发管理和项目实施 。' 
        },
        { 
          'avatar-img': 'https://ustatic.hudongmiao.com/miao/common/sxg_1768211443948598ddd.webp', 
          introduction: '上小官，上海嗨喵网络科技有限公司市场总监，传奇（中国）主持人联盟成员，胡白徒弟，中华司仪婚尚达人，中华婚庆网络评选风云人物，10余年婚礼主持，培育出了主持人、演讲师、营销达人以及多位网络直播带货官，上小官具备强劲的执行力和区域影响力，在市场开拓、婚庆人职业化等方面积累了宝贵的经验。' 
        },
        { 
          'avatar-img': 'https://ustatic.hudongmiao.com/miao/common/rjs_1768211443948e90afc.webp', 
          introduction: '任家松，上海嗨喵网络科技有限公司董事长兼CEO，河海大学学士，复旦大学博士，曾任职上市公司诺德股份（600110）副董事长，杉杉集团（600884）常务副总经理、杉杉科技总经理，作为天使投资人参与创办和投资了多家高科技企业，拥有丰富的资本运作经验和深厚的互联网产业资源。' 
        },
        { 
          'avatar-img': 'https://ustatic.hudongmiao.com/miao/common/lwm_1768211443945ce2a6d.webp', 
          introduction: '李伟民，上海嗨喵网络科技有限公司CFO，中国注册会计师、中国注册税务师，作为税务顾问曾参与了杉杉集团上市财务顾问;为多家集团公司提供业务重组税务安排,为多家跨国公司及A股上市公司提供重组税务咨询意见及税务安排。' 
        },
      ],
      isDragging: false,
      startX: 0,
      dragOffset: 0,
    };
  },
  computed: {
    dragStyle() {
      if (this.isDragging && this.dragOffset !== 0) {
        return {
          '--drag-offset': `${this.dragOffset}px`,
        };
      }
      return {
        '--drag-offset': '0px',
      };
    },
  },
  methods: {
    goToSlide(index) {
      if (index >= 0 && index < this.cards.length) {
        this.activeIndex = index;
      }
    },
    handleMouseDown(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.dragOffset = 0;
    },
    handleMouseMove(e) {
      if (!this.isDragging) return;
      this.dragOffset = e.clientX - this.startX;
    },
    handleMouseUp() {
      if (!this.isDragging) return;
      this.isDragging = false;
      
      const threshold = 100;
      if (this.dragOffset < -threshold && this.activeIndex < this.cards.length - 1) {
        this.activeIndex += 1;
      } else if (this.dragOffset > threshold && this.activeIndex > 0) {
        this.activeIndex -= 1;
      }
      
      this.dragOffset = 0;
    },
    handleTouchStart(e) {
      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.dragOffset = 0;
    },
    handleTouchMove(e) {
      if (!this.isDragging) return;
      this.dragOffset = e.touches[0].clientX - this.startX;
    },
    handleTouchEnd() {
      this.handleMouseUp();
    },
  },
};
</script>

<style lang="less" scoped>
// 尺寸变量 - 所有尺寸都在 CSS 中定义，便于 postcss 处理
@container-width: 1440px;
@active-width: 692px;
@active-height: 382px;
@inactive-width: 609px;  // 692 * 0.88
@inactive-height: 336px; // 382 * 0.88
@gap: 30px;
@active-font-size: 18px;
@active-line-height: 30px;
@inactive-font-size: 15.84px;  // 18 * 0.88
@inactive-line-height: 26.4px; // 30 * 0.88
@active-padding: 40px;
@inactive-padding: 35.2px; // 40 * 0.88
@active-avatar-width: 290px;
@inactive-avatar-width: 255.2px; // 290 * 0.88
@active-intro-width: 402px;
@inactive-intro-width: 353.76px; // 402 * 0.88

// 计算居中偏移基础值: (1440 - 692) / 2 = 374px
@center-offset: 374px;
// 每次切换需要移动的距离: 609 + 30 = 639px
@slide-step: 639px;

.introduction-content2 {
  width: 100%;
  height: auto;
  margin-top: 88px;
  
  .title-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    
    .title-text {
      font-weight: 700;
      font-size: 32px;
      line-height: 1;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .title-text-en {
      font-weight: 500;
      font-size: 18px;
      line-height: 1.5;
      background: linear-gradient(to bottom, #CA5EFB 46%, #844DFE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin-top: 12px;
    }
  }
  
  .carousel-wrapper {
    width: @container-width;
    margin: 40px auto 0;
    overflow: hidden;
  }
  
  .carousel-container {
    width: 100%;
    overflow: hidden;
    position: relative;
    height: @active-height;
    display: flex;
    align-items: center;
  }
  
  .carousel-track {
    display: flex;
    align-items: center;
    cursor: grab;
    user-select: none;
    transition: transform 0.4s ease-out;
    --drag-offset: 0px;
    
    &:active {
      cursor: grabbing;
    }
    
    &.dragging {
      transition: none;
    }
    
    // 不同激活索引对应的偏移量
    // index 0: 374px
    // index 1: 374 - 639 = -265px
    // index 2: 374 - 639*2 = -904px
    // index 3: 374 - 639*3 = -1543px
    &.active-index-0 {
      transform: translateX(calc(@center-offset + var(--drag-offset)));
    }
    
    &.active-index-1 {
      transform: translateX(calc(@center-offset - @slide-step + var(--drag-offset)));
    }
    
    &.active-index-2 {
      transform: translateX(calc(@center-offset - @slide-step * 2 + var(--drag-offset)));
    }
    
    &.active-index-3 {
      transform: translateX(calc(@center-offset - @slide-step * 3 + var(--drag-offset)));
    }
  }
  
  .carousel-card {
    flex-shrink: 0;
    border-radius: 16px;
    overflow: hidden;
    transition: width 0.4s ease-out, height 0.4s ease-out;
    width: @inactive-width;
    height: @inactive-height;
    margin-right: @gap;
    
    &:last-child {
      margin-right: 0;
    }
    
    .card-content {
      width: 100%;
      height: 100%;
      display: flex;
      
      .avatar-container {
        width: @inactive-avatar-width;
        height: 100%;
        background: #0B104C;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: width 0.4s ease-out;
        
        .avatar-img {
          height: 100%;
          width: auto;
          object-fit: contain;
          user-select: none;
          -webkit-user-drag: none;
          pointer-events: none;
        }
      }
      
      .intro-container {
        width: @inactive-intro-width;
        height: 100%;
        background: linear-gradient(90deg, #212A92 0%, rgba(135, 65, 209, 1) 30%);
        flex-shrink: 0;
        padding: 0 @inactive-padding;
        display: flex;
        align-items: center;
        transition: width 0.4s ease-out, padding 0.4s ease-out;
        
        .intro-text {
          font-weight: 500;
          font-size: @inactive-font-size;
          color: #FFFFFF;
          line-height: @inactive-line-height;
          text-align: justify;
          width: 100%;
          transition: font-size 0.4s ease-out, line-height 0.4s ease-out;
        }
      }
    }
    
    &.active {
      width: @active-width;
      height: @active-height;
      
      .avatar-container {
        width: @active-avatar-width;
      }
      
      .intro-container {
        width: @active-intro-width;
        padding: 0 @active-padding;
        
        .intro-text {
          font-size: @active-font-size;
          line-height: @active-line-height;
        }
      }
    }
  }
  
  .carousel-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    margin-top: 58px;
    
    .dot {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: rgba(138, 77, 254, 0.3);
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(138, 77, 254, 0.6);
      }
      
      &.active {
        width: 38px;
        border-radius: 8px;
        background: linear-gradient(90deg, #CA5EFB 0%, #844DFE 100%);
      }
    }
  }
}
</style>
